import { render, staticRenderFns } from "./ExaminationBoardCard.vue?vue&type=template&id=00578568&"
import script from "./ExaminationBoardCard.vue?vue&type=script&lang=ts&"
export * from "./ExaminationBoardCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports